import { toast } from "react-toastify";
import { HttpValidationProblemDetails } from "@/lib/gen";
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
};

export const setErrors = (data: HttpValidationProblemDetails | void) => {
  const title =
    data?.title || "We could not process your request. Please try again.";
  const validationErrors = Object.values(data?.errors || {});
  const errors = [title, ...validationErrors].flatMap((e) => e);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  errors.forEach((error:any) => toast.error(error));
};
